// extracted by mini-css-extract-plugin
export default {"snackbar":"Snackbar_snackbar__NURdk","show":"Snackbar_show__vS9xH","hide":"Snackbar_hide__nHIJI","success":"Snackbar_success__6L+iG","error":"Snackbar_error__lj9UL"};